export const createReqBody = filter => {
  return {
    filters: {
      search: filter.companyName ? filter.companyName : '*',
      status: filter.status[0] ? filter.status : '*',
      companySize: filter.companySize[0] ? filter.companySize : '*',
      plan: filter.plan[0] ? filter.plan : '*',
      billingCycle: filter.billingCycle[0] ? filter.billingCycle : '*',
      healthStatus: filter.healthStatus[0] ? filter.healthStatus : '*',
      accountManager: filter.accountManager[0] ? filter.accountManager : '*',
      customerSuccessEngineer: filter.customerSuccessEngineer[0]
        ? filter.customerSuccessEngineer
        : '*',
      healthPoint: {
        from: filter.healthPoint.from ? filter.healthPoint.from : '*',
        to: filter.healthPoint.to ? filter.healthPoint.to : '*'
      },

      arr: {
        from: filter.arr.from ? filter.arr.from : '*',
        to: filter.arr.to ? filter.arr.to : '*'
      },
      npsScore: {
        from: filter.npsScore.from ? filter.npsScore.from : '*',
        to: filter.npsScore.to ? filter.npsScore.to : '*'
      },
      openTickets: {
        from: filter.openTickets.from ? filter.openTickets.from : '*',
        to: filter.openTickets.to ? filter.openTickets.to : '*'
      },
      csatChatScore: {
        from: filter.csatChatScore.from ? filter.csatChatScore.from : '*',
        to: filter.csatChatScore.to ? filter.csatChatScore.to : '*'
      },
      csatTicketScore: {
        from: filter.csatTicketScore.from ? filter.csatTicketScore.from : '*',
        to: filter.csatTicketScore.to ? filter.csatTicketScore.to : '*'
      },
      csatChatNum: {
        from: filter.csatChatNum.from ? filter.csatChatNum.from : '*',
        to: filter.csatChatNum.to ? filter.csatChatNum.to : '*'
      },
      csatTicketNum: {
        from: filter.csatTicketNum.from ? filter.csatTicketNum.from : '*',
        to: filter.csatTicketNum.to ? filter.csatTicketNum.to : '*'
      }
    },
    sort: {
      fieldName: filter.fieldName,
      direction: filter.direction
    }
  };
};
